var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOutlineBeenhereCircle64Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 15.5H21.5C19.85 15.5 18.515 16.85 18.515 18.5L18.5 37.895C18.5 38.93 19.025 39.845 19.82 40.385L32 48.5L44.165 40.385C44.96 39.845 45.485 38.93 45.485 37.895L45.5 18.5C45.5 16.85 44.15 15.5 42.5 15.5ZM32 44.9L21.5 37.91V18.5H42.5V37.895L32 44.9ZM28.985 33.77L25.115 29.885L23 32L29 38L41 26L38.87 23.87L28.985 33.77Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineBeenhereCircle64Px);
export default __webpack_public_path__ + "static/media/ic_outline-beenhere_circle-64px.adb79baeeb34b477a450655ac6f188e2.svg";
export { ForwardRef as ReactComponent };